/*! 
 * Moka is a content management system created by tix02.be
 * It only intended to be used by the clients of tix02 and 
 * cannot be modified.
 * ©2018-2022 tix02.be 
**/

import Windows from './windows';
import '../vendors/jquery.are-you-sure';
import './chosen';
import './popover';
import './scrollbar';
import './search';
import './sidebar';
import './utils';




$(document).ajaxSend((e, xhr, options) => {
	const token = $("meta[name='csrf-token']").attr('content');
	xhr.setRequestHeader('X-CSRF-Token', token);
});


	
	
/* 
 * Ajax Delete From index pages 
 *
 * @param params objectOf 
 * - element: reference of this
 * - url: the base url for the module (like /moka/posts/delete)
 * - id: item id
 * - confirm: the confirm message, fallback to messages.confirmDelete if not present
 * @param String context (index or single)
 *
 */
function moka_delete_item(params, context) {	
	if(! params.confirm ) {
		params.confirm = messages.confirmDelete;
	}
	
	if(! confirm(params.confirm)) {
		return;
	}
	
	if(! context) {
		context = 'single';
	}
	
	$.post(
		params.url +'/'+ params.data.id,
		params.data, 
		function(response) {
			if( response.code != 200 )
				return alert(messages.internalError);
			
			if( context === 'index' ) {
				var $tr = $(params.element).closest('tr');
				$tr.slideUp(400, function() {
					$tr.remove();		
				});
				
				return true;
			}
			
			if( context === 'associated_item' ) {
				var $ai = $(params.element).closest('.associated-item');
				$ai.slideUp(400, function() {
					$ai.remove();		
				});
				
				return true;
			}
			
			if( context === 'media_index' ) {
				var $li = $(params.element).closest('.moka-media-item');
				$li.fadeOut(400, function() {
					$li.remove();		
				});
				
				return true;
			}
			
			if( params.redirect ) {
				document.location.href = params.redirect;
				return true;
			}
			
			return true;
		}
	);
};



window.moka_delete_item = moka_delete_item;



let mokaWindows;



$.when( $.ready ).then(() => {
	mokaWindows = new Windows();
	window.mokaWindows = mokaWindows;
	const fixedSubmit = document.getElementById('form-submit-fixed');
	if( fixedSubmit ) {
		window.onscroll = () => {
			if( window.pageYOffset > 200 ) {
				return fixedSubmit.classList.add('shown');
			} 
			fixedSubmit.classList.remove('shown');
		};
	}
	
	$('form.form-prevent-loss').areYouSure({ message: messages.preventLosingChanges });
		
	$('body').on('click', 'a.overlay-view-url', function(e) {
		e.preventDefault();
		
		$.get($(this).attr('href'), function(response) {
			mokaWindows.open(response);
		});
	});
	
	/*
	document.addEventListener('mokaWindowOpen', () => {
		alert('open');
	}, false);
	
	document.addEventListener('mokaWindowClose', () => {
		alert('open');
	}, false);
	
	document.addEventListener('mokaWindowSwitch', () => {
		alert('open');
	}, false);
	
	*/
});